export default "__VITE_ASSET__63c6bab1__"